import { render } from "./WCBottomNavigation.vue?vue&type=template&id=7101bd59&scoped=true"
import script from "./WCBottomNavigation.vue?vue&type=script&lang=js"
export * from "./WCBottomNavigation.vue?vue&type=script&lang=js"

import "./WCBottomNavigation.vue?vue&type=style&index=0&id=7101bd59&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7101bd59"]])

export default __exports__